import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { merge } from "lodash-es";
import { V2ConfirmationDialogComponent } from "libs/vui/src/lib/v2-confirmation-dialog/dialog.component";
import { FuseConfirmationConfig } from "@nx-workspace/fuse";

@Injectable()
export class V2ConfirmationService {
    private _defaultConfig: FuseConfirmationConfig = {
        title: "Confirm action",
        message: "Are you sure you want to confirm this action?",
        icon: {
            show: true,
            name: "heroicons_outline:exclamation",
            color: "warn",
        },
        actions: {
            confirm: {
                show: true,
                label: "Confirm",
                color: "warn",
            },
            cancel: {
                show: true,
                label: "Cancel",
            },
            discard: {
                show: false,
                label: "Discard",
            },
        },
        dismissible: false,
    };

    /**
     * Constructor
     */
    constructor(private _matDialog: MatDialog) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    openV2(config: FuseConfirmationConfig = {}): MatDialogRef<V2ConfirmationDialogComponent> {
        // Merge the user config with the default config
        const userConfig = merge({}, this._defaultConfig, config);
        // Open the dialog
        return this._matDialog.open(V2ConfirmationDialogComponent, {
            autoFocus: false,
            disableClose: !userConfig.dismissible,
            data: userConfig,
            panelClass: "fuse-confirmation-dialog-panel",
        });
    }
}
